// @ts-nocheck
import { Alert, FirmRecord } from '@tassat/fred-definitions';

import { download } from 'Lib/exportHelper';
import { formatEpochDate } from 'Lib/stringHelpers';
import adminStore from 'Reducers/store/adminStore';

export const exportAlerts = (alerts: Alert[]) => {
    let exportString = 'Date/Time, Firm, Username, Account, Requester Username, Alert Type, Alert Message, Reference ID \n';
    const state = adminStore.getState();

    alerts.forEach(alert => {
        const alertTimeFormatted = formatEpochDate(alert.AlertTime);
        const firm: FirmRecord = state.firms[alert.FirmId];
        exportString += `"${alertTimeFormatted}","${firm?.Name ? firm.Name : (alert?.FirmName || '')}","${alert.Username}","${alert.AccountName}","${alert.RequesterUsername}","${alert.AlertCode}","${alert.AlertDescription}",="${alert.RequestId}"\n`;
    });

    download('Lynq_Platform_Alerts.csv', exportString);
};